import type { ReactElement } from "react"
import React from "react"
import _t from "@core/i18n"
import ExpandableContentOrg from "@onestore/hel/dist/components/organisms/ExpandableContentOrg"
import MarkdownText from "@gatsby-plugin-generic-page/components/Markdown/Text"
import { sendContentShowEvent } from "~/lib/analytics"
import type { SquidexMarkdownEmbeddedContent } from "~/types/squidex"
import markdownOverrides from "./markdownOverrides"

interface ProductDescriptionProps {
  productDescription: SquidexMarkdownEmbeddedContent
}

export default function ProductDescription({
  productDescription,
}: ProductDescriptionProps): ReactElement<ProductDescriptionProps> {
  return (
    <ExpandableContentOrg
      showMoreDetails={{
        text: _t("showMore"),
        title: _t("showMore"),
        onClick: sendContentShowEvent,
      }}
    >
      <MarkdownText
        overrides={markdownOverrides}
        typography={{ default: "medium1_h", bold: "medium3_h" }}
        forceBlock={false}
      >
        {productDescription}
      </MarkdownText>
    </ExpandableContentOrg>
  )
}
